/**
 * Generated by Orval
 * Do not edit manually.
 * Sell To API
 * OpenAPI spec version: v3
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EntitiesAnnouncementCollectionListResponse,
  EntitiesAnnouncementMemberMain,
  ListAnnouncementsParams
} from '../../models';

import { customInstance } from '../../../../services/api';
import type { ErrorType } from '../../../../services/api';
import { customQueryOptions } from '../../../../mutators/customQueryOptions';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary List announcements
 */
export const listAnnouncements = (
    params?: ListAnnouncementsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesAnnouncementCollectionListResponse>(
      {url: `/api/v3/announcements`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListAnnouncementsInfiniteQueryKey = (params?: ListAnnouncementsParams,) => {
    return [
    'infinite', `/api/v3/announcements`, ...(params ? [params] : [])
    ] as const;
    }

export const getListAnnouncementsQueryKey = (params?: ListAnnouncementsParams,) => {
    return [
    `/api/v3/announcements`, ...(params ? [params] : [])
    ] as const;
    }


export const useListAnnouncementsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(params?: ListAnnouncementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnnouncementsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnnouncements>>> = ({ signal }) => listAnnouncements(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnnouncementsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listAnnouncements>>>
export type ListAnnouncementsInfiniteQueryError = ErrorType<unknown>


export function useListAnnouncementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListAnnouncementsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof listAnnouncements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof listAnnouncements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List announcements
 */

export function useListAnnouncementsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAnnouncementsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List announcements
 */
export const prefetchListAnnouncementsInfiniteQuery = async <TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListAnnouncementsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListAnnouncementsInfiniteQueryOptions(params,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListAnnouncementsInfinite} query
 */
export const invalidateListAnnouncementsInfinite = async (
 queryClient: QueryClient, params?: ListAnnouncementsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListAnnouncementsInfiniteQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListAnnouncementsQueryOptions = <TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnnouncementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnnouncements>>> = ({ signal }) => listAnnouncements(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnnouncementsQueryResult = NonNullable<Awaited<ReturnType<typeof listAnnouncements>>>
export type ListAnnouncementsQueryError = ErrorType<unknown>


export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params: undefined |  ListAnnouncementsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof listAnnouncements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAnnouncements>>,
          TError,
          Awaited<ReturnType<typeof listAnnouncements>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List announcements
 */

export function useListAnnouncements<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAnnouncementsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary List announcements
 */
export const prefetchListAnnouncementsQuery = async <TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, params?: ListAnnouncementsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useListAnnouncementsQueryOptions(params,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useListAnnouncements} query
 */
export const invalidateListAnnouncements = async (
 queryClient: QueryClient, params?: ListAnnouncementsParams, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getListAnnouncementsQueryKey(params) }).queryKey }, options);

  return queryClient;
}




export const useListAnnouncementsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnnouncementsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnnouncements>>> = ({ signal }) => listAnnouncements(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnnouncementsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof listAnnouncements>>>
export type ListAnnouncementsSuspenseQueryError = ErrorType<unknown>


export function useListAnnouncementsSuspense<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params: undefined |  ListAnnouncementsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncementsSuspense<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncementsSuspense<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List announcements
 */

export function useListAnnouncementsSuspense<TData = Awaited<ReturnType<typeof listAnnouncements>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAnnouncementsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useListAnnouncementsSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAnnouncementsInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAnnouncements>>> = ({ signal }) => listAnnouncements(params, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListAnnouncementsSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof listAnnouncements>>>
export type ListAnnouncementsSuspenseInfiniteQueryError = ErrorType<unknown>


export function useListAnnouncementsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params: undefined |  ListAnnouncementsParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncementsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListAnnouncementsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List announcements
 */

export function useListAnnouncementsSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof listAnnouncements>>>, TError = ErrorType<unknown>>(
 params?: ListAnnouncementsParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof listAnnouncements>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListAnnouncementsSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Show announcement
 */
export const showAnnouncement = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<EntitiesAnnouncementMemberMain>(
      {url: `/api/v3/announcements/${id}`, method: 'GET', signal
    },
      options);
    }




export const getShowAnnouncementInfiniteQueryKey = (id: string,) => {
    return [
    'infinite', `/api/v3/announcements/${id}`
    ] as const;
    }

export const getShowAnnouncementQueryKey = (id: string,) => {
    return [
    `/api/v3/announcements/${id}`
    ] as const;
    }


export const useShowAnnouncementInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowAnnouncementInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showAnnouncement>>> = ({ signal }) => showAnnouncement(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowAnnouncementInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showAnnouncement>>>
export type ShowAnnouncementInfiniteQueryError = ErrorType<unknown>


export function useShowAnnouncementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showAnnouncement>>,
          TError,
          Awaited<ReturnType<typeof showAnnouncement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showAnnouncement>>,
          TError,
          Awaited<ReturnType<typeof showAnnouncement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show announcement
 */

export function useShowAnnouncementInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowAnnouncementInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show announcement
 */
export const prefetchShowAnnouncementInfiniteQuery = async <TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowAnnouncementInfiniteQueryOptions(id,options)

  await queryClient.infiniteQuery(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowAnnouncementInfinite} query
 */
export const invalidateShowAnnouncementInfinite = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowAnnouncementInfiniteQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowAnnouncementQueryOptions = <TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowAnnouncementQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showAnnouncement>>> = ({ signal }) => showAnnouncement(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions});

   return  customOptions as UseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowAnnouncementQueryResult = NonNullable<Awaited<ReturnType<typeof showAnnouncement>>>
export type ShowAnnouncementQueryError = ErrorType<unknown>


export function useShowAnnouncement<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof showAnnouncement>>,
          TError,
          Awaited<ReturnType<typeof showAnnouncement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncement<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof showAnnouncement>>,
          TError,
          Awaited<ReturnType<typeof showAnnouncement>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncement<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show announcement
 */

export function useShowAnnouncement<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowAnnouncementQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Show announcement
 */
export const prefetchShowAnnouncementQuery = async <TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 queryClient: QueryClient, id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}

  ): Promise<QueryClient> => {

  const queryOptions = useShowAnnouncementQueryOptions(id,options)

  await queryClient.query(queryOptions).catch(() => {});

  return queryClient;
}

/**
 * @summary Invalidates the {@link useShowAnnouncement} query
 */
export const invalidateShowAnnouncement = async (
 queryClient: QueryClient, id: string, options?: InvalidateOptions
  ): Promise<QueryClient> => {

  await queryClient.invalidateQueries({ queryKey: customQueryOptions({ queryKey: getShowAnnouncementQueryKey(id) }).queryKey }, options);

  return queryClient;
}




export const useShowAnnouncementSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowAnnouncementQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showAnnouncement>>> = ({ signal }) => showAnnouncement(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowAnnouncementSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof showAnnouncement>>>
export type ShowAnnouncementSuspenseQueryError = ErrorType<unknown>


export function useShowAnnouncementSuspense<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncementSuspense<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncementSuspense<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show announcement
 */

export function useShowAnnouncementSuspense<TData = Awaited<ReturnType<typeof showAnnouncement>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowAnnouncementSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const useShowAnnouncementSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getShowAnnouncementInfiniteQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof showAnnouncement>>> = ({ signal }) => showAnnouncement(id, requestOptions, signal);



      const customOptions = customQueryOptions({ queryKey, queryFn, ...queryOptions});

   return  customOptions as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ShowAnnouncementSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof showAnnouncement>>>
export type ShowAnnouncementSuspenseInfiniteQueryError = ErrorType<unknown>


export function useShowAnnouncementSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncementSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useShowAnnouncementSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Show announcement
 */

export function useShowAnnouncementSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof showAnnouncement>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof showAnnouncement>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useShowAnnouncementSuspenseInfiniteQueryOptions(id,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






